export enum EnumPais {
  ES = 1, // ESPAÑA
  AF = 2, // AFGANISTÁN
  AL = 3, // ALBANIA
  DE = 4, // ALEMANIA
  DZ = 5, // ALGERIA
  AD = 6, // ANDORRA
  AO = 7, // ANGOLA
  AI = 8, // ANGUILA
  AQ = 9, // ANTÁRTIDA
  AG = 10, // ANTIGUA Y BARBUDA
  SA = 11, // ARABIA SAUDITA
  AR = 12, // ARGENTINA
  AM = 13, // ARMENIA
  AW = 14, // ARUBA
  AU = 15, // AUSTRALIA
  AT = 16, // AUSTRIA
  AZ = 17, // AZERBAIYÁN
  BE = 18, // BÉLGICA
  BS = 19, // BAHAMAS
  BH = 20, // BAHREIN
  BD = 21, // BANGLADESH
  BB = 22, // BARBADOS
  BZ = 23, // BELICE
  BJ = 24, // BENÍN
  BT = 25, // BHUTÁN
  BY = 26, // BIELORRUSIA
  MM = 27, // BIRMANIA
  BO = 28, // BOLIVIA
  BA = 29, // BOSNIA Y HERZEGOVINA
  BW = 30, // BOTSUANA
  BR = 31, // BRASIL
  BN = 32, // BRUNÉI
  BG = 33, // BULGARIA
  BF = 34, // BURKINA FASO
  BI = 35, // BURUNDI
  CV = 36, // CABO VERDE
  KH = 37, // CAMBOYA
  CM = 38, // CAMERÚN
  CA = 39, // CANADÁ
  TD = 40, // CHAD
  CL = 41, // CHILE
  CN = 42, // CHINA
  CY = 43, // CHIPRE
  VA = 44, // CIUDAD DEL VATICANO
  CO = 45, // COLOMBIA
  KM = 46, // COMORAS
  CG = 47, // REPÚBLICA DEL CONGO
  CD = 48, // REPÚBLICA DEMOCRÁTICA DEL CONGO
  KP = 49, // COREA DEL NORTE
  KR = 50, // COREA DEL SUR
  CI = 51, // COSTA DE MARFIL
  CR = 52, // COSTA RICA
  HR = 53, // CROACIA
  CU = 54, // CUBA
  CW = 55, // CURAZAO
  DK = 56, // DINAMARCA
  DM = 57, // DOMINICA
  EC = 58, // ECUADOR
  EG = 59, // EGIPTO
  SV = 60, // EL SALVADOR
  AE = 61, // EMIRATOS ÁRABES UNIDOS
  ER = 62, // ERITREA
  SK = 63, // ESLOVAQUIA
  SI = 64, // ESLOVENIA
  US = 65, // ESTADOS UNIDOS DE AMÉRICA
  EE = 66, // ESTONIA
  ET = 67, // ETIOPÍA
  PH = 68, // FILIPINAS
  FI = 69, // FINLANDIA
  FJ = 70, // FIYI
  FR = 71, // FRANCIA
  GA = 72, // GABÓN
  GM = 73, // GAMBIA
  GE = 74, // GEORGIA
  GH = 75, // GHANA
  GI = 76, // GIBRALTAR
  GD = 77, // GRANADA
  GR = 78, // GRECIA
  GL = 79, // GROENLANDIA
  GP = 80, // GUADALUPE
  GU = 81, // GUAM
  GT = 82, // GUATEMALA
  GF = 83, // GUAYANA FRANCESA
  GG = 84, // GUERNSEY
  GN = 85, // GUINEA
  GQ = 86, // GUINEA ECUATORIAL
  GW = 87, // GUINEA-BISSAU
  GY = 88, // GUYANA
  HT = 89, // HAITÍ
  HN = 90, // HONDURAS
  HK = 91, // HONG KONG
  HU = 92, // HUNGRÍA
  IN = 93, // INDIA
  ID = 94, // INDONESIA
  IR = 95, // IRÁN
  IQ = 96, // IRAK
  IE = 97, // IRLANDA
  BV = 98, // ISLA BOUVET
  IM = 99, // ISLA DE MAN
  CX = 100, // ISLA DE NAVIDAD
  NF = 101, // ISLA NORFOLK
  IS = 102, // ISLANDIA
  BM = 103, // ISLAS BERMUDAS
  KY = 104, // ISLAS CAIMÁN
  CC = 105, // ISLAS COCOS (KEELING)
  CK = 106, // ISLAS COOK
  AX = 107, // ISLAS DE ÅLAND
  FO = 108, // ISLAS FEROE
  GS = 109, // ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR
  HM = 110, // ISLAS HEARD Y MCDONALD
  MV = 111, // ISLAS MALDIVAS
  FK = 112, // ISLAS MALVINAS
  MP = 113, // ISLAS MARIANAS DEL NORTE
  MH = 114, // ISLAS MARSHALL
  PN = 115, // ISLAS PITCAIRN
  SB = 116, // ISLAS SALOMÓN
  TC = 117, // ISLAS TURCAS Y CAICOS
  UM = 118, // ISLAS ULTRAMARINAS MENORES DE ESTADOS UNIDOS
  VG = 119, // ISLAS VÍRGENES BRITÁNICAS
  VI = 120, // ISLAS VÍRGENES DE LOS ESTADOS UNIDOS
  IL = 121, // ISRAEL
  IT = 122, // ITALIA
  JM = 123, // JAMAICA
  JP = 124, // JAPÓN
  JE = 125, // JERSEY
  JO = 126, // JORDANIA
  KZ = 127, // KAZAJISTÁN
  KE = 128, // KENIA
  KG = 129, // KIRGUISTÁN
  KI = 130, // KIRIBATI
  KW = 131, // KUWAIT
  LB = 132, // LÍBANO
  LA = 133, // LAOS
  LS = 134, // LESOTO
  LV = 135, // LETONIA
  LR = 136, // LIBERIA
  LY = 137, // LIBIA
  LI = 138, // LIECHTENSTEIN
  LT = 139, // LITUANIA
  LU = 140, // LUXEMBURGO
  MX = 141, // MÉXICO
  MC = 142, // MÓNACO
  MO = 143, // MACAO
  MK = 144, // MACEDÔNIA
  MG = 145, // MADAGASCAR
  MY = 146, // MALASIA
  MW = 147, // MALAWI
  ML = 148, // MALI
  MT = 149, // MALTA
  MA = 150, // MARRUECOS
  MQ = 151, // MARTINICA
  MU = 152, // MAURICIO
  MR = 153, // MAURITANIA
  YT = 154, // MAYOTTE
  FM = 155, // MICRONESIA
  MD = 156, // MOLDAVIA
  MN = 157, // MONGOLIA
  ME = 158, // MONTENEGRO
  MS = 159, // MONTSERRAT
  MZ = 160, // MOZAMBIQUE
  NA = 161, // NAMIBIA
  NR = 162, // NAURU
  NP = 163, // NEPAL
  NI = 164, // NICARAGUA
  NE = 165, // NIGER
  NG = 166, // NIGERIA
  NU = 167, // NIUE
  NO = 168, // NORUEGA
  NC = 169, // NUEVA CALEDONIA
  NZ = 170, // NUEVA ZELANDA
  OM = 171, // OMÁN
  NL = 172, // PAÍSES BAJOS
  PK = 173, // PAKISTÁN
  PW = 174, // PALAU
  PS = 175, // PALESTINA
  PA = 176, // PANAMÁ
  PG = 177, // PAPÚA NUEVA GUINEA
  PY = 178, // PARAGUAY
  PE = 179, // PERÚ
  PF = 180, // POLINESIA FRANCESA
  PL = 181, // POLONIA
  PT = 182, // PORTUGAL
  PR = 183, // PUERTO RICO
  QA = 184, // QATAR
  GB = 185, // REINO UNIDO
  CF = 186, // REPÚBLICA CENTROAFRICANA
  CZ = 187, // REPÚBLICA CHECA
  DO = 188, // REPÚBLICA DOMINICANA
  SS = 189, // REPÚBLICA DE SUDÁN DEL SUR
  RE = 190, // REUNIÓN
  RW = 191, // RUANDA
  RO = 192, // RUMANÍA
  RU = 193, // RUSIA
  EH = 194, // SAHARA OCCIDENTAL
  WS = 195, // SAMOA
  AS = 196, // SAMOA AMERICANA
  BL = 197, // SAN BARTOLOMÉ
  KN = 198, // SAN CRISTÓBAL Y NIEVES
  SM = 199, // SAN MARINO
  MF = 200, // SAN MARTÍN (FRANCIA)
  PM = 201, // SAN PEDRO Y MIQUELÓN
  VC = 202, // SAN VICENTE Y LAS GRANADINAS
  SH = 203, // SANTA ELENA
  LC = 204, // SANTA LUCÍA
  ST = 205, // SANTO TOMÉ Y PRÍNCIPE
  SN = 206, // SENEGAL
  RS = 207, // SERBIA
  SC = 208, // SEYCHELLES
  SL = 209, // SIERRA LEONA
  SG = 210, // SINGAPUR
  SX = 211, // SINT MAARTEN
  SY = 212, // SIRIA
  SO = 213, // SOMALIA
  LK = 214, // SRI LANKA
  ZA = 215, // SUDÁFRICA
  SD = 216, // SUDÁN
  SE = 217, // SUECIA
  CH = 218, // SUIZA
  SR = 219, // SURINÁM
  SJ = 220, // SVALBARD Y JAN MAYEN
  SZ = 221, // SWAZILANDIA
  TJ = 222, // TAYIKISTÁN
  TH = 223, // TAILANDIA
  TW = 224, // TAIWÁN
  TZ = 225, // TANZANIA
  IO = 226, // TERRITORIO BRITÁNICO DEL OCÉANO ÍNDICO
  TF = 227, // TERRITORIOS AUSTRALES Y ANTÁRTICAS FRANCESES
  TL = 228, // TIMOR ORIENTAL
  TG = 229, // TOGO
  TK = 230, // TOKELAU
  TO = 231, // TONGA
  TT = 232, // TRINIDAD Y TOBAGO
  TN = 233, // TUNEZ
  TM = 234, // TURKMENISTÁN
  TR = 235, // TURQUÍA
  TV = 236, // TUVALU
  UA = 237, // UCRANIA
  UG = 238, // UGANDA
  UY = 239, // URUGUAY
  UZ = 240, // UZBEKISTÁN
  VU = 241, // VANUATU
  VE = 242, // VENEZUELA
  VN = 243, // VIETNAM
  WF = 244, // WALLIS Y FUTUNA
  YE = 245, // YEMEN
  DJ = 246, // YIBUTI
  ZM = 247, // ZAMBIA
  ZW = 248 // ZIMBABUE
}
